import { render, staticRenderFns } from "./FolderModal.vue?vue&type=template&id=39d35f47&scoped=true"
import script from "./FolderModal.vue?vue&type=script&lang=js"
export * from "./FolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d35f47",
  null
  
)

export default component.exports